import React from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';

const EditTableModal = ({ isOpen, toggle, onSubmit, formData, handleInputChange }) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(formData);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Table</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="identification">Identification</Label>
            <Input
              type="text"
              name="identification"
              id="identification"
              value={formData.identification}
              onChange={handleInputChange}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="description">Description</Label>
            <Input
              type="text"
              name="description"
              id="description"
              value={formData.description}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleInputChange}
              />{' '}
              Active
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                name="isOccupied"
                checked={formData.isOccupied}
                onChange={handleInputChange}
              />{' '}
              Occupied
            </Label>
          </FormGroup>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button color="primary" type="submit">
            Update
          </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default EditTableModal;